import React from 'react';

import { Box } from '@mui/material';
import { useCart } from 'services/Data/CartService';
import Checkout from 'routes/Pages/Checkout/Checkout';
import { useParams } from 'react-router-dom';
import ProfilePreviousProject from './ProfilePreviousProject';

const OrderDetail = ({ fromHistory }) => {
  let { cartId } = useParams();
  const { data: historyCart } = useCart(cartId);

  return (
    <Box>
      {historyCart?.project_Id && (
        <Box>
          <ProfilePreviousProject projectIdFromParent={historyCart?.project_Id} />
        </Box>
      )}
      <Box>
        <Checkout fromHistory={fromHistory} />
      </Box>
    </Box>
  );
};

export default OrderDetail;
